module.exports = __webpack_public_path__ + "img/Banner-Website-DAB-Investor-Relation.0ca34b28.jpg";